import { render, staticRenderFns } from "./colapsever.vue?vue&type=template&id=5f236a2b"
import script from "./colapsever.vue?vue&type=script&lang=js"
export * from "./colapsever.vue?vue&type=script&lang=js"
import style0 from "./colapsever.vue?vue&type=style&index=0&id=5f236a2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports